import { createFileRoute, redirect } from '@tanstack/react-router';

// The case search is the support's home page.
export const Route = createFileRoute('/_app/')({
	loader: () => redirect({ to: '/cases' }),
});
